<section class="operations-page">
    <header class="operations-page__header">
        <div>
            <h2 class="operations-page__title">Overview</h2>
            <p class="operations-page__lead">Provider status, health, and quick navigation.</p>
        </div>
    </header>

    <p class="operations-page__loading" *ngIf="loading">Loading provider overview…</p>

    <div class="operations-detail-grid" *ngIf="!loading && summary">
        <app-metadata-panel title="Provider Summary" [entries]="overviewEntries"></app-metadata-panel>

        <section class="operations-page__card">
            <h3 class="operations-page__title">Quick Links</h3>
            <div class="operations-links">
                <a class="operations-links__item"
                   [routerLink]="['/vision-configuration/provider-management/providers', providerId, 'authentication']">
                    Authentication
                </a>
                <a class="operations-links__item"
                   [routerLink]="['/vision-configuration/provider-management/providers', providerId, 'event-subscriptions']">
                    Event Subscriptions
                </a>
                <a class="operations-links__item"
                   [routerLink]="['/vision-configuration/provider-management/providers', providerId, 'diagnostics']">
                    Diagnostics
                </a>
            </div>
        </section>
    </div>
</section>
